import {Component, Inject, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {environment} from '@/environments/environment';
import {fromEvent, map} from 'rxjs';
import {NavigationEnd, Router, Scroll} from '@angular/router';
import {NativeService} from "@/app/services/native.service";
import {DOCUMENT} from "@angular/common";
import {User} from "@/app/model/user";
import {UserService} from "@/app/services/user.service";
import moment from 'moment-timezone';
import {CookieService} from "@/app/services/cookie.service";
import {useTranslationWithFallback} from "@/app/shared/translation";

const VALID_BRANDS = ['enelx', 'consumersenergy', 'dte', 'evergy', 'endesa', 'demo', 'agora'];

@Component({
    selector: 'app-root',
    standalone: false,  // Change from true to false
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
    locale: any;
    routeBrand = '';
    readonly isMobile: boolean;
    navBarUrl = environment.globalNavUrl;

    constructor(
        private readonly cookieService: CookieService,
        private readonly router: Router,
        private readonly translate: TranslateService,
        private nativeService: NativeService,
        private userService: UserService,
        @Inject(DOCUMENT) protected _document: Document,
    ) {
        this.isMobile = this.nativeService.isMobileDevice();

        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.updateRouteBrand(event.urlAfterRedirects);
            }
        });
        fromEvent(window, 'user')
            .pipe(map(event => (event as CustomEvent).detail['user'] as User))
            .subscribe(user => {
                const locale = user.preferences.defaultLocale;
                moment.locale(locale);
                this.userService.user = user;
            });
    }

    ngOnInit(): void {
        const {defaults} = environment;
        this.locale = this.cookieService.getI18NLocale() || defaults.locale;
        const brand = this.cookieService.getI18NBrand() || defaults.brand.toUpperCase();
        this.translate.setDefaultLang(`${defaults.locale}.${defaults.brand.toUpperCase()}`);
        useTranslationWithFallback(this.translate, this.locale, brand).subscribe();
        this.updateRouteBrand(this.router.url);
    }

    private updateRouteBrand(url: string): void {
        const urlParts = url.split('/').filter(part => part);
        if (urlParts.length > 0 && VALID_BRANDS.includes(urlParts[0])) {
            this.routeBrand = urlParts[0];
        } else {
            this.routeBrand = '';
        }
    }

    getRoutePrefix(): string {
        return this.routeBrand ? `/${this.routeBrand}` : '';
    }
}
